
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 
 import {ObcAppMenu as ObcAppMenuElement} from '@oicl/openbridge-webcomponents/dist/components/app-menu/app-menu.js';
 
 
 

 
 export const ObcAppMenu = createComponent({
   react: React,
   tagName: 'obc-app-menu',
   elementClass: ObcAppMenuElement,
   events: {
     
     onSearch: 'search' as EventName<CustomEvent<string>>,
   }
  });
 
 